import { TFilterSelected } from '../filter.types';
import { TPaginationInfo } from '../input-app/fabric-inspection/api.types';
import { TFactoryId } from './factory.types';
import { TLocationDetails, TRESPONSE_LOCATION_LIST } from './location-management-API.types';
import { TTicketId } from './ticket-management-API.types';

export type TREQUEST_EMPLOYEE_LIST = {
  factoryId: TFactoryId;
  selectedFilters: TFilterSelected[];
  page: number;
  itemsPerPage: number;
};

export type TRESPONSE_EMPLOYEE_LIST = TEmployeeListingDTO;

export type TRESPONSE_ISSUE_CATEGORIES_AND_MACHINE_TYPE_DROPDOWN_INFO = {
  issueCategories: string[];
  machineTypes: string[];
};

export type TREQUEST_UPDATE_EMPLOYEE = {
  employee: TEmployee;
  issueCategories: string[];
  machineTypes: string[];
};

export type TREQUEST_EMPLOYEE_REPLACEMENTS = {
  employeeId: TEmployee['employeeId'];
};

export type TREQUEST_EMPLOYEE_REPLACEMENTS_FOR_TICKETS = {
  ticketId: TTicketId;
};
export type TRESPONSE_EMPLOYEE_REPLACEMENTS_FOR_MACHINE_ISSUE_TICKETS = {
  employeeReplacements: {
    employeeDetails: TMinimalEmployeeDetailsV2;
    availabilityType: TAVAILABILITY_TYPE;
  }[];
};

export type TRESPONSE_DELETE_EMPLOYEE_REPLACEMENTS = {
  employeeReplacements: EMPLOYEE_REPLACEMENTS[];
};

type EMPLOYEE_REPLACEMENTS = {
  employeeDetails: TMinimalEmployeeDetails;
  availabilityType: TAVAILABILITY_TYPE;
};

export type TAVAILABILITY_TYPE = 'AVAILABLE' | 'BUSY' | 'WAITING_FOR_APPROVAL';

export type TREQUEST_DELETE_EMPLOYEE = {
  factoryId: TFactoryId;
  employeeIdToDelete: TEmployee['employeeId'];
  employeeReplacements?: TEmployeeReplacementForLocation[];
};

type TEmployeeReplacementForLocation = {
  replacementEmployeeId: TEmployee['employeeId'];
  locationId: TLocationDetails['id'];
};

type TEmployeeListingDTO = {
  employeesWithAssignments: TEmployeeWithAssignments[];
  filters: TFilterSelected[];
  paginationInfo: TPaginationInfo;
  userSelectedFilters: TFilterSelected[];
};

type TEmployeeWithAssignments = {
  employee: TEmployee;
  assignedLocations: Omit<TRESPONSE_LOCATION_LIST['locationDetails'][number], 'assignedEmployeeDetails'>[];
  issueCategories: string[];
  machineTypes: string[];
};

export type TMinimalEmployeeDetails = {
  employeeId: TEmployee['employeeId'];
  employeeName: TEmployee['name'];
  employeeRole: TEmployee['role'];
};

export type TMinimalEmployeeDetailsV2 = TMinimalEmployeeDetails & { employeeEntityId: number; factoryId: string };

export type TEmployeeRole = [
  'FACTORY_GROUP_ADMIN',
  'ADMIN',
  'MECHANIC',
  'LINE_SUPERVISOR',
  'MAINTENANCE_MANAGER',
  'MAINTENANCE_TICKET_ASSIGN_ENGINEER',
  'NEEDLE_EXECUTIVE',
  'SPAREPART_EXECUTIVE',
  'FACTORY_ADMIN',
  'MANAGER',
  'LOCAL_NEEDLE_STORE_MANAGER',
  'GLOBAL_NEEDLE_STORE_MANAGER',
  'ELECTRICIAN',
  'ELECTRICAL_MANAGER',
  'MAINTENANCE_INCHARGE',
];

export type TEmployee = {
  employeeId: string;
  name: string;
  emailId?: string;
  contactNumber?: string;
  role: TEmployeeRole[number];
  username: string;
  factoryId: string;
};

export const EMPLOYEE_ROLE_DISPLAY_STR = {
  FACTORY_GROUP_ADMIN: 'Factory Group Admin',
  ADMIN: 'assign_employee.Admin',
  MECHANIC: 'assign_employee.Mechanic',
  LINE_SUPERVISOR: 'assign_employee.LineSupervisor',
  ELECTRICIAN: 'assign_employee.Electrician',
  ELECTRICAL_MANAGER: 'assign_employee.ElectricalManager',
  MAINTENANCE_MANAGER: 'assign_employee.MaintenanceManager',
  MAINTENANCE_TICKET_ASSIGN_ENGINEER: 'assign_employee.MaintenanceTicketAssignEngineer',
  NEEDLE_EXECUTIVE: 'assign_employee.NeedleExecutive',
  SPAREPART_EXECUTIVE: 'assign_employee.SparepartExecutive',
  FACTORY_ADMIN: 'assign_employee.FactoryAdmin',
  MANAGER: 'assign_employee.Manager',
  LOCAL_NEEDLE_STORE_MANAGER: 'assign_employee.LocalNeedleStoreManager',
  GLOBAL_NEEDLE_STORE_MANAGER: 'assign_employee.GlobalNeedleStoreManager',
  MAINTENANCE_INCHARGE: 'assign_employee.MaintenanceIncharge',
};
